<template>
  <div>
    <div style="width:30px;height:30px;position:fixed;top:0;right:0;" @click="escPrint"></div>
<div class="no-print" style="width:30px;height:30px;position:fixed;top:0;right:0;" @click="makePrintable">print</div>
    <section class="sheet padding-10mm">
      <map-view :mainObj="myData" class=""></map-view>
    </section>
    
  </div>
</template>


<script>
import { ApiTls } from "../../src/app/tools/ApiTls";
// import { MapTls } from '../app/tools/MapTls';
// import { MapTls } from "../../src/app/tools/MapTls";
// import { BoundTls } from "../app/tools/BoundTls";
import { PrintTls } from "../app/tools/PrintTls";
// import ExcelTextView from '../components/excelTextView.vue';
import MapView from "../components/MapView";

export default {
  components: { MapView },
  name: "Feeder",
  data() {
    return {
      feederId: 0,
      feederData: {},
      myData: {},
    };
  },
  mounted() {
    ApiTls.getFeederData(this.$route.params.feederId, this.setResData);
  },
  methods: {
    setResData(res) {
      this.myData = res.data;
    },
    makePrintable() {
      PrintTls.makePrintable();
    },
    escPrint() {
      PrintTls.escPrintable();
    },
  },
};
</script>



<style scoped>
</style>
